export default __webpack_public_path__ + "static/smart-city-main-4c8d62755138458d5dc945734ac9c0d3.jpg";